/**
 * Parte un texto de plantilla en tramos: lo escrito y lo que es una variable.
 *
 * Vive aparte del componente porque es la única pieza con reglas, y porque el
 * mismo regex lo usa el backend para decidir qué variables pide una plantilla
 * (`extractVariables`). Si los dos dejaran de coincidir, la previa enseñaría un
 * hueco donde el servidor ve una variable, o al revés.
 */

/** El mismo de `email-resend.templateRender.extractVariables`. */
const VARIABLE = /\{\{\s*([\w.]+)\s*\}\}/g;

/**
 * @param {string} texto
 * @returns {Array<{tipo: 'texto', valor: string} | {tipo: 'variable', nombre: string}>}
 */
export function partirPorVariables(texto) {
  const cadena = String(texto ?? '');
  const tramos = [];
  let desde = 0;

  // `matchAll` y no `exec` en bucle: el regex es global y reutilizarlo entre
  // llamadas arrastra `lastIndex`, que es un fallo intermitente de manual.
  for (const encontrada of cadena.matchAll(VARIABLE)) {
    if (encontrada.index > desde) {
      tramos.push({ tipo: 'texto', valor: cadena.slice(desde, encontrada.index) });
    }
    tramos.push({ tipo: 'variable', nombre: encontrada[1] });
    desde = encontrada.index + encontrada[0].length;
  }

  if (desde < cadena.length) tramos.push({ tipo: 'texto', valor: cadena.slice(desde) });

  return tramos;
}

/**
 * Las ops del editor de cuerpo (Quill) como el texto plano que verá el deudor.
 *
 * Un botón es un bloque dentro del cuerpo —`{ insert: { button: { label, href } } }`—
 * y en texto plano el backend lo escribe `label: href` (`buttonsToText`). Se hace
 * lo mismo aquí: saltárselo dejaría que la previa afirmara por omisión que el
 * correo no lleva botón, que es lo peor que puede hacer una previa.
 */
export function textoDeOps(ops) {
  return (Array.isArray(ops) ? ops : [])
    .map(op => {
      if (typeof op?.insert === 'string') return op.insert;
      const boton = op?.insert?.button;
      if (!boton) return '';
      return [boton.label, boton.href].filter(Boolean).join(': ');
    })
    .join('');
}
